import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false
export const bus = new Vue();
Vue.use(require('vue-jalali-moment'));
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
